import React, { useContext } from "react";
import { useNavigate } from "../../hooks/useNavigate";
import { HistoryContext } from "../../redux/historyContext";
import { CaseListTile } from "./TileRenderers/CaseListTile";
import { CountTile } from "./TileRenderers/CountTile";
import { ErrorTile } from "./TileRenderers/ErrorTile";
import { ListTile } from "./TileRenderers/ListTile";
import { TotalCountTile } from "./TileRenderers/TotalCountTile";
export const DashboardTile = ({ tile }) => {
    const { location } = useContext(HistoryContext);
    const navigate = useNavigate(location);
    const navigateToFilter = (filterUrl) => navigate(`${filterUrl}&DashboardTitle=${tile.title}`);
    return React.createElement(React.Fragment, null, getTileRenderer(tile, navigateToFilter));
};
const getTileRenderer = (tile, navigate) => {
    tile.parsedData = JSON.parse(tile.data);
    if (!tile.parsedData || !tile.parsedData.length) {
        return React.createElement(ErrorTile, { tile: tile });
    }
    switch (tile.type) {
        case "Ofqual.CountTile":
            return React.createElement(CountTile, { tile: tile, navigate: navigate });
        case "Ofqual.TotalCountTile":
            return React.createElement(TotalCountTile, { tile: tile, navigate: navigate });
        case "Ofqual.ListTile":
            return React.createElement(ListTile, { tile: tile, navigate: navigate });
        case "Ofqual.CaseListTile":
            return React.createElement(CaseListTile, { tile: tile, navigate: navigate });
        default:
            return null;
    }
};
